import apiClient from './apiClient';
import type {
    TestMetric,
    CreateTestMetricDto,
    UpdateTestMetricDto,
} from '../types/types';

const testMetricsService = {
    getAll: async (): Promise<TestMetric[]> => {
        const res = await apiClient.get<TestMetric[]>('/test-metrics');
        return res.data;
    },

    getById: async (id: number): Promise<TestMetric> => {
        const res = await apiClient.get<TestMetric>(`/test-metrics/${id}`);
        return res.data;
    },

    getByType: async (type: string): Promise<TestMetric> => {
        const res = await apiClient.get<TestMetric>(`/test-metrics/by-type/${encodeURIComponent(type)}`);
        return res.data;
    },

    create: async (dto: CreateTestMetricDto): Promise<TestMetric> => {
        const res = await apiClient.post<TestMetric>('/test-metrics', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateTestMetricDto): Promise<TestMetric> => {
        const res = await apiClient.patch<TestMetric>(`/test-metrics/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/test-metrics/${id}`);
        return res.data;
    },
};

export default testMetricsService;
